import "babel-polyfill";

import * as React from "react";
import * as ReactDOM from "react-dom";
import registerServiceWorker from "./registerServiceWorker";
import { HashRouter, Route, Switch } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore } from "redux";

import HomeScreen from "./components/HomeScreen";
import SelectScreen from "./components/SelectScreen";
import ReportScreen from "./components/ReportScreen";
import "./index.css";

import rootReducer from './reducers';

const store = createStore(rootReducer, (window as any).__REDUX_DEVTOOLS_EXTENSION__ && (window as any).__REDUX_DEVTOOLS_EXTENSION__());

ReactDOM.render(
  <Provider store={store}>
    <HashRouter>
      <Switch>
        <Route exact={true} path="/" component={HomeScreen} />
        <Route exact={true} path="/select" component={SelectScreen} />
        <Route exact={true} path="/report" component={ReportScreen} />
      </Switch>
    </HashRouter>
  </Provider>,
  document.getElementById("root") as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx